'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (layout, extraOptions) {
    var series = void 0;

    switch (layout.type) {
        case _.CHART_TYPE_GAUGE:
            series = (0, _gauge2.default)(layout, extraOptions.legendSet);
            break;
        default:
            series = getDefault(layout);
    }

    return series;
};

var _arrayClean = require('d2-utilizr/lib/arrayClean');

var _arrayClean2 = _interopRequireDefault(_arrayClean);

var _objectClean = require('d2-utilizr/lib/objectClean');

var _objectClean2 = _interopRequireDefault(_objectClean);

var _isNumeric = require('d2-utilizr/lib/isNumeric');

var _isNumeric2 = _interopRequireDefault(_isNumeric);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _getAxisTitle = require('../getAxisTitle');

var _getAxisTitle2 = _interopRequireDefault(_getAxisTitle);

var _ = require('..');

var _gauge = require('./gauge');

var _gauge2 = _interopRequireDefault(_gauge);

var _type = require('../type');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MIN_VALUE = 0;

var DEFAULT_GRIDLINE_COLOR = '#E1E1E1';

var DEFAULT_PLOTLINE = {
    color: '#000',
    width: 2,
    zIndex: 4
};

var DEFAULT_PLOTLINE_LABEL = {
    y: -7,
    style: {
        fontSize: 13,
        textShadow: '0 0 6px #FFF'
    }
};

function getMinValue(layout) {
    return (0, _isNumeric2.default)(layout.rangeAxisMinValue) ? layout.rangeAxisMinValue : DEFAULT_MIN_VALUE;
}

function getMaxValue(layout) {
    return (0, _isNumeric2.default)(layout.rangeAxisMaxValue) ? layout.rangeAxisMaxValue : undefined;
}

function getSteps(layout) {
    return (0, _isNumeric2.default)(layout.rangeAxisSteps) ? layout.rangeAxisSteps : undefined;
}

function getTargetLine(layout) {
    return (0, _isNumeric2.default)(layout.targetLineValue) ? _extends({}, DEFAULT_PLOTLINE, (0, _objectClean2.default)({
        value: layout.targetLineValue,
        label: (0, _isString2.default)(layout.targetLineTitle) ? _extends({}, DEFAULT_PLOTLINE_LABEL, {
            text: layout.targetLineTitle
        }) : undefined
    })) : undefined;
}

function getBaseLine(layout) {
    return (0, _isNumeric2.default)(layout.baseLineValue) ? _extends({}, DEFAULT_PLOTLINE, (0, _objectClean2.default)({
        value: layout.baseLineValue,
        label: (0, _isString2.default)(layout.baseLineTitle) ? _extends({}, DEFAULT_PLOTLINE_LABEL, {
            text: layout.baseLineTitle
        }) : undefined
    })) : undefined;
}

function getFormatter(layout) {
    return {
        formatter: function formatter() {
            return this.value.toFixed(layout.rangeAxisDecimals);
        }
    };
}

function getLabels(layout) {
    return (0, _isNumeric2.default)(layout.rangeAxisDecimals) ? getFormatter(layout) : undefined;
}

function getDefault(layout) {
    return (0, _objectClean2.default)({
        min: getMinValue(layout),
        max: getMaxValue(layout),
        tickAmount: getSteps(layout),
        title: (0, _getAxisTitle2.default)(layout.rangeAxisTitle),
        plotLines: (0, _arrayClean2.default)([getTargetLine(layout), getBaseLine(layout)]),
        gridLineColor: DEFAULT_GRIDLINE_COLOR,
        labels: getLabels(layout),

        // DHIS2-649: put first serie at the bottom of the stack
        // in this way the legend sequence matches the serie sequence
        reversedStacks: (0, _type.getIsStacked)(layout.type) ? false : true
    });
}
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/yAxis/index.js
 ** module id = 210
 ** module chunks = 0 1
 **/